import './WeatherForecast.scss';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchWeather } from 'src/module/weather/action';
import { getClient } from 'src/module/authentication/selector';
import { getWeatherForecast } from 'src/module/weather/selector';
import { celsiusToFahrenheitConvertor } from 'src/utils/utils';
import { getTemperatureUnit } from 'src/module/authentication/selector';
import { useTranslation } from 'src/i18n/useTranslation';

import DayForecast from './DayForecast';

const DAY_KEYS = [
  'weather.day.sunday',
  'weather.day.monday',
  'weather.day.tuesday',
  'weather.day.wednesday',
  'weather.day.thursday',
  'weather.day.friday',
  'weather.day.saturday',
];

const MONTH_KEYS = [
  'weather.month.january',
  'weather.month.february',
  'weather.month.march',
  'weather.month.april',
  'weather.month.may',
  'weather.month.june',
  'weather.month.july',
  'weather.month.august',
  'weather.month.september',
  'weather.month.october',
  'weather.month.november',
  'weather.month.december',
];

export default function WeatherForecast () {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const temperatureUnit = useSelector(getTemperatureUnit);
  const weatherForecast = useSelector(getWeatherForecast);
  const client = useSelector(getClient);

  useEffect(() => {
    dispatch(fetchWeather());
  }, [client.get('id')]);

  const cityName = weatherForecast.get('city') || null;
  const forecast = weatherForecast.get('forecast') || null;

  const formatDay = (currentDay: any): string => {
    if (currentDay.get('isToday')) {
      return t('weather.day.today');
    }
    if (currentDay.get('isTomorrow')) {
      return t('weather.day.tomorrow');
    }
    const dayIndex = currentDay.get('dayIndex');
    if (dayIndex !== undefined && DAY_KEYS[dayIndex]) {
      return t(DAY_KEYS[dayIndex]);
    }
    // Fallback for old API format
    return currentDay.get('day') || '';
  };

  const formatDate = (currentDay: any): string => {
    const monthIndex = currentDay.get('monthIndex');
    const dayOfMonth = currentDay.get('dayOfMonth');
    if (monthIndex !== undefined && dayOfMonth !== undefined && MONTH_KEYS[monthIndex]) {
      return `${t(MONTH_KEYS[monthIndex])} ${dayOfMonth}`;
    }
    // Fallback for old API format
    return currentDay.get('date') || '';
  };

  return cityName ? (
    <div id='weather-forecast' data-testid='weather-forecast'>
      <h3>{t('weather.dayForecast', { city: cityName })}</h3>

      <div className='weather'>
        {forecast && forecast.reduce((days: any, currentDay: any, index: any) => {
          if (currentDay && days.length < 5) {
            days.push(<DayForecast
              maxTemp={temperatureUnit === 'C' ? currentDay.get('high') : celsiusToFahrenheitConvertor(parseFloat(currentDay.get('high').replace('°C', ''))) + '°F'}
              minTemp={temperatureUnit === 'C' ? currentDay.get('low') : celsiusToFahrenheitConvertor(parseFloat(currentDay.get('low').replace('°C', ''))) + '°F'}
              day={formatDay(currentDay)}
              iconCode={currentDay.get('code')}
              date={formatDate(currentDay)}
              key={index}
            />);
          }
          return days;
        }, [])}
      </div>
    </div>
  ) : null;
}

WeatherForecast.propTypes = {
};

WeatherForecast.defaultProps = {
};
